import { getCityInfo } from '../api/logistic';
import { COUNTRY_CHECK_MESSAGE, normalizeCargoCountryCode } from './cargoNameValidation';

/**
 * Resolve the selected cities again before registering an invoice.
 * @param {{contract_number: string, cityFrom: number, cityTo: number}} data
 * @returns {Promise<{cityFromCountryCode: number|string, cityToCountryCode: number|string, source_country_code: string, destination_country_code: string}>}
 */
export async function resolveInvoiceCountries(data) {
    if (!data.contract_number || !data.cityFrom || !data.cityTo) {
        throw new Error(COUNTRY_CHECK_MESSAGE);
    }
    const [from, to] = await Promise.all([
        getCityInfo({contract_number: data.contract_number, code: data.cityFrom}),
        getCityInfo({contract_number: data.contract_number, code: data.cityTo}),
    ]);
    if (!from || !to || Number(from.code) !== Number(data.cityFrom) || Number(to.code) !== Number(data.cityTo) ||
        !/^[A-Z]{2}$/.test(from.country_code ?? '') || !/^[A-Z]{2}$/.test(to.country_code ?? '')) {
        throw new Error(COUNTRY_CHECK_MESSAGE);
    }
    return {
        cityFromCountryCode: normalizeCargoCountryCode(from.country_code),
        cityToCountryCode: normalizeCargoCountryCode(to.country_code),
        source_country_code: from.country_code,
        destination_country_code: to.country_code,
    };
}
